import { combineReducers, configureStore } from "@reduxjs/toolkit";
import type { TypedUseSelectorHook } from "react-redux";
import {
    useDispatch as useDispatchBase,
    useSelector as useSelectorBase,
} from "react-redux";
import { dataReducer } from "./data";

const rootReducer = combineReducers({
    data: dataReducer,
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: false,
        }),
});

export const useDispatch = () => useDispatchBase<typeof store.dispatch>();
export type RootState = ReturnType<typeof store.getState>;
export const useSelector: TypedUseSelectorHook<RootState> = useSelectorBase;

export default store;
